import { addLatex, addMathJax, MATH_RENDER_ENGINE_BACKOFFICE } from 'app/config/configLatex';

export function initializeLatex() {
  window.mathRenderEngineFroalaV3 = MATH_RENDER_ENGINE_BACKOFFICE;
  addLatex(MATH_RENDER_ENGINE_BACKOFFICE);
  // Pre-reclamamos window.MathJax con v3 antes de que monten Mint/Lemonade, para que
  // usen nuestra instancia (vía shim) en lugar de cargar su CDN 2.7.7.
  addMathJax();
}
